// components/SellHeader.jsx

export function SellHeader() {
  return (
    <div className="bahubali">
      <div className="about-mainheading">Sell Your Masterpiece</div>
      <div className="about-subheading">"Turn Your Art Into Opportunity"</div>
    </div>
  );
}
